import { Link } from "gatsby"
import React from "react"

import * as styles from "./BookDemo.module.css"

type ButtonLinkProps = {
  url: string
  secondaryColor?: string
  style?: React.CSSProperties
  bgColor?: string
  textColor?: string
  radius?: number | string
  text: string
  size?: number
  selfCenter?: boolean
  secondaryTextColor?: string
  external?: boolean
}

export const ButtonLink = ({
  bgColor = "#015AB4",
  secondaryColor = "#023063",
  secondaryTextColor = "#fff",
  style,
  textColor = "white",
  url,
  radius = 5,
  text,
  size = 16,
  selfCenter,
  external,
}: ButtonLinkProps) => {
  const styles_ = React.useMemo(
    () => ({
      backgroundColor: bgColor,
      color: textColor,
      borderRadius: radius,
      fontSize: size,
      padding: "5px 50px",
      ["--secondary-color" as any]: secondaryColor,
      ["--secondary-text-color" as any]: secondaryTextColor,
      margin: selfCenter ? "0 auto" : undefined,
      ...style,
    }),
    []
  )
  return external ? (
    <a
      className={styles.link}
      style={styles_}
      target="_blank"
      rel="noreferrer"
      href={url}
    >
      {text}
    </a>
  ) : (
    <Link
      className={styles.link}
      style={styles_}
      target="_blank"
      rel="noreferrer"
      to={url}
    >
      {text}
    </Link>
  )
}
